import { render, staticRenderFns } from "./IncomeMenu.vue?vue&type=template&id=6d9f979c&scoped=true"
import script from "./IncomeMenu.vue?vue&type=script&lang=js"
export * from "./IncomeMenu.vue?vue&type=script&lang=js"
import style0 from "./IncomeMenu.vue?vue&type=style&index=0&id=6d9f979c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9f979c",
  null
  
)

export default component.exports